import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Control, Errors } from 'react-redux-form';
import { FormControl, FormGroup, ControlLabel, Row, Col} from 'react-bootstrap';
import RequiredDatepicker from '../elements/required-datepicker';

class AbmSelector extends Component {
  abmUserList = () => {
    const { abmReliefsMeta } = this.props;

    if (!abmReliefsMeta) {
      return [];
    }

    return abmReliefsMeta.map(abmRelief => ({
      label: `${abmRelief.name}`,
      value: abmRelief.id
    }));
  }

  render() {
    const { abmRelief } = this.props;

    return (
      <div className='container-fluid'>
        <Row>
          <Col lg={4}>
            <FormGroup controlId="abmReliefUser">
              <ControlLabel>
                ABM Relief
              </ControlLabel>
              <Control.select
                component={FormControl}
                componentClass="select"
                model="deep.admin_user.edit.abm_relief.abm_relief_user_id"
              >
                <option value="">
                  Select ABM Relief...
                </option>
                {
                  this.abmUserList().map(item => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))
                }
              </Control.select>
              <Errors
                className="errors"
                messages={{ required: 'This field is required' }}
                model="deep.admin_user.edit.abm_relief.abm_relief_user_id"
                show={{
                  touched: true,
                  focus: false
                }}
              />
            </FormGroup>
          </Col>
          <Col lg={4}>
            <RequiredDatepicker
              label={'Relief Period Start Date'}
              model={'deep.admin_user.edit.abm_relief.start_date'}
              placeholder="Start Date"
              required={!!abmRelief.abm_relief_user_id}
              disabled={!abmRelief.abm_relief_user_id}
              value={abmRelief.start_date}
            />
          </Col>
          <Col lg={4}>
            <RequiredDatepicker
              label={'Relief Period End Date'}
              model={'deep.admin_user.edit.abm_relief.end_date'}
              placeholder="End Date"
              required={!!abmRelief.abm_relief_user_id}
              disabled={!abmRelief.abm_relief_user_id}
              value={abmRelief.end_date}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  abmReliefsMeta: state.users.editorInput['abm-reliefs'],
  abmRelief: state.deep.admin_user.edit.abm_relief
});

export default connect(mapStateToProps)(AbmSelector);



// WEBPACK FOOTER //
// ./src/components/common/form/user/abm-selector.jsx